module.exports = __webpack_public_path__ + "img/Path 19 Copy@3x.a3518405.png";